const currentState = {
    approvals: {
        data: null,
        error: null
    },
    approvalCategories: {
        data: null,
        error: null
    },
    approvalStatuses: {
        data: null,
        error: null
    },
    approvalYearHistory: {
        data: null,
        error: null
    },
    companyGroups: {
        data: null,
        error: null
    }
};

const reducer = (state = currentState, action) => {
    switch(action.type) {
        case 'INSTANTIATE_APPROVALS':
            const approvals = {...state.approvals};
            
            if(null !== action.payload.approvals) 
                approvals.data = action.payload.approvals;
            
            approvals.error = action.payload.error ?? false;

            return {
                ...state,
                approvals: approvals
            };
        case 'APPEND_APPROVALS': {
            const currentApprovals = {...state.approvals};
            const existing = Array.isArray(currentApprovals.data) ? currentApprovals.data : [];
            const incoming = Array.isArray(action.payload) ? action.payload : [];
            const existingIds = new Set(existing.map(approval => approval.id));

            currentApprovals.data = existing.concat(
                incoming.filter(approval => !existingIds.has(approval.id))
            );

            return {
                ...state,
                approvals: currentApprovals
            };
        }
        case 'INSTANTIATE_CATEGORIES':
            const categories = {...state.approvalCategories};
            categories.data = action.payload.categories;
            categories.error = action.payload.error ?? false;

            return {
                ...state,
                approvalCategories: categories
            };
        case 'INSTANTIATE_STATUSES':
            const statuses = {...state.approvalStatuses};
            statuses.data = action.payload.statuses;
            statuses.error = action.payload.error ?? false;

            return {
                ...state,
                approvalStatuses: statuses
            };
        case 'INSTANTIATE_YEAR_HISTORY':
            const yearHistory = {...state.approvalYearHistory};
            yearHistory.data = action.payload.yearHistory;
            yearHistory.error = action.payload.error;

            return {
                ...state, 
                approvalYearHistory: yearHistory
            };
        case 'INSTANTIATE_GROUPS_APPROVALS':
            const groups = {...state.companyGroups};
            groups.data = action.payload.groups;
            groups.error = action.payload.error;

            return {
                ...state,
                companyGroups: groups
            };
        case 'CREATE_APPROVAL':
            const currentApprovals = {...state.approvals};
            const approvalData = currentApprovals.data

            approvalData.unshift(action.payload);
            currentApprovals.data = approvalData;

            return {
                ...state,
                approvals: currentApprovals
            }
        case 'UPDATE_APPROVAL':
            const apps = {...state.approvals};
            const _data = apps.data

            const ind = _data.findIndex(approval => approval.id === action.payload.id);
            _data.splice(ind, 1, action.payload);

            apps.data = _data;

            return {
                ...state,
                approvals: apps
            }
        case 'DELETE_APPROVAL':
            const pristineApprovals = {...state.approvals};
            const data = [...pristineApprovals.data];
            const index = data.findIndex(approval => approval.id === action.payload);

            data.splice(index, 1);
            pristineApprovals.data = data;

            return {
                ...state,
                approvals: pristineApprovals
            }
        case 'RESET_APPROVALS':
            const _ = {...state.approvals};
            _.data = null;
            _.error = null;

            return {
                ...state,
                approvals: _
            };
        default:
            return state;
    }
};

export default reducer;
